import { OverlayView } from "@react-google-maps/api";
import { Cluster } from "../utils/mapUtils";
import { MapDevice } from "../../../api/admin";
import DSBox from "../../system-design/DSBox";
import LoopPreview from "./LoopPreview";

type DeviceClusterProps = {
  cluster: Cluster<MapDevice>;
  onClusterClick: (cluster: Cluster<MapDevice>) => void;
};

const DeviceCluster = ({ cluster, onClusterClick }: DeviceClusterProps) => {
  const firstDevice = cluster.devices[0];

  if (!firstDevice.loopUrl) return null;

  return (
    <OverlayView
      position={{
        lat: cluster.location.latitude,
        lng: cluster.location.longitude,
      }}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <DSBox sx={{ position: "relative" }}>
        <DSBox
          onClick={() => onClusterClick(cluster)}
          sx={{
            right: "11px",
            width: "24px",
            height: "24px",
            borderRadius: "50%",
            position: "relative",
            overflow: "hidden",
            cursor: "pointer",
          }}
        >
          <DSBox
            sx={{
              display: "flex",
              justifyContent: "center",
              position: "absolute",
              top: "0%",
              left: "0%",
              width: "100%",
              aspectRatio: "1/1",
            }}
          >
            <LoopPreview
              loopUrl={firstDevice.loopUrl}
              alt="cluster"
              size={48}
            />
          </DSBox>
        </DSBox>
      </DSBox>
    </OverlayView>
  );
};

export default DeviceCluster;
